document.addEventListener('DOMContentLoaded', function () {
  const wrapper = document.querySelector('.modalrightfilter-wrapper');
  const modal = document.querySelector('.modalrightfilter-wrapper .modalrightfilter');
  const customFilter = document.querySelector('.custom-filter');
  if (!wrapper || !modal) return;

  // Ouvrir le filtre latéral
  document.querySelectorAll('.filter-button').forEach(function (button) {
    button.addEventListener('click', function () {
      wrapper.style.display = 'block';
      customFilter?.classList.add('getontop');
      setTimeout(function () {
        modal.classList.add('active');
      }, 100);
    });
  });

  // Fermer le filtre latéral
  document.querySelectorAll('.close-btn, .blockvide, .modalrightfilter .links').forEach(function (el) {
    el.addEventListener('click', function () {
      modal.classList.remove('active');
      setTimeout(function () {
        wrapper.style.display = 'none';
        customFilter?.classList.remove('getontop');
      }, 300);
    });
  });

  // Scroll fluide vers les ancres
  document.querySelectorAll('.links a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        window.scrollTo({ top: target.offsetTop - 100, behavior: 'smooth' });
      }
    });
  });
});
